import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { RootState } from 'typesafe-actions';

export const AdsBannerInsTag = ({
  zoneId,
  bannerId = 'ads-banner',
}: {
  zoneId: string;
  bannerId?: string;
}) => {
  const adsId = config.ad_id;

  const { activePublicKey } = useSelector((state: RootState) => state.wallet);

  useEffect(() => {
    document.querySelectorAll(`ins[data-revive-id]`).forEach((ins) => {
      ins.removeAttribute('data-revive-loaded');
      ins.setAttribute('data-revive-pb', activePublicKey || '');
    });

    if (window.reviveAsync && window.reviveAsync[adsId]) {
      window.reviveAsync[adsId].refresh();
    }
  }, [activePublicKey]);

  useEffect(() => {
    const ins = document.querySelector(`.${bannerId}`);
    ins?.removeAttribute('data-revive-loaded');
    ins?.setAttribute('data-revive-zoneid', zoneId || '');

    if (window.reviveAsync && window.reviveAsync[adsId]) {
      window.reviveAsync[adsId].refresh();
    }
  }, [zoneId]);

  return (
    <ins
      data-revive-zoneid={zoneId}
      data-revive-id={adsId}
      data-revive-pb={activePublicKey || ''}
      className={bannerId}
    />
  );
};
